import { UploadUsersProvider } from './provider';
import { UploadComponent } from '../../csv-importer/csv-upload-wizard';
import { CONTEXT_TYPE } from '../use-upload-context-factory';

export function UsersUploadWizard() {
  return (
    <UploadUsersProvider>
      <UploadComponent contextType={CONTEXT_TYPE.USERS} />
    </UploadUsersProvider>
  );
}
